
import { Modal } from "react-bootstrap";
import { popCancelBttn } from "../../assets";
import { useEffect, useState } from "react";
import Button from "../Button";
import './CreateFolderPopUp.css';
import ApiServices from "../../utils/apiServices";
import AlertMessagePopUpModal from "../PopUp/AlertMessagePopUpModal";

 const DeletePopUp = (props) =>{
    //const selectedId = props.selectedID[0];
    const [alertMessage, setAlertMessage] = useState("");
    const [alertMessageShowModal,setAlertMessageShowModal] = useState(false);
    const [selectedFolderID ,setSelectedFolderID] = useState([])
    const [selectedFileID ,setSelectedFileID] = useState([])
    
    useEffect(()=>{
        if(props.selectedID){
            let filterFolder = props.selectedID.filter(x => x.folderid && !(x.docid) ).map( x => x.folderid)
            let filterFile = props.selectedID.filter( x => x.docid).map(x => x.docid)  
            setSelectedFolderID(filterFolder)
            setSelectedFileID(filterFile)   
        }
    },[props.selectedID])

    const handleDelete = async () => {
        const service = new ApiServices();
        if(selectedFolderID.length > 0){
            if (handleValidation()){
            //api
            let res = await service.deleteFolder(selectedFolderID);
        if (res) {
            setAlertMessage("Folder  Deleted successfully");
            setAlertMessageShowModal(true)
        }
    }
       }
        if(selectedFileID.length > 0) {
            if (handleValidation()){
                //api
                let res = await service.deleteFiles(selectedFileID)
            if (res) {
                setAlertMessage("File Deleted successfully");
                setAlertMessageShowModal(true);
            }
        }
        }
    }
    const handleValidation = () =>{
        return true
    }
    const closeAlertMessage = () => {
        props.setSelectedID();
        setAlertMessage("");
        setAlertMessageShowModal(false);

    }
    return (<>
        <Modal
            show={props.showModal}
            size="lg md sm xs"
            centered
            aria-labelledby="contained-modal-title-vcenter"
            dialogClassName="popup-transition"
            scrollable={false}
        >
            <div style={{ borderTop: `5px solid #1DA1E5`, overflow: "auto" }}>
                <div className="popup-cancel-btn-wrapper">
                    <img
                        src={popCancelBttn}
                        alt=""
                        onClick={e => {
                            props.handleClose()
                        }}
                    />
                </div>
                <div>
                    <Modal.Header className="gsfModalHeader" style={{ justifyContent: "left" }}>
                        <div style={{ textAlign: "center", width: "30%", paddingTop: "1%" }}>
                            <Modal.Title>
                                <div>
                                    Delete File
                                </div>
                            </Modal.Title>
                        </div>
                    </Modal.Header>
                    <Modal.Body scrollable={true} style={{ maxHeight: "40vh", padding: " 1rem 3rem" }}>
                    <div className="text" style={{ marginLeft:'50px'}}>Are you sure you want to delete the selected item ? This action is irreversible.
                    </div>
                        <div className="reading-list-button-wrapper1">
                            <div style={ { display: "flex" , justifyContent:"space-between" , width:"20%"}}>
                            <Button text="Delete" customColor='#0074B0' action={() => {
                                handleDelete()
                            }} />
                            <Button text="Cancel" customColor="#0074B0" action={() => {
                                props.handleClose()
                            }} />
                        </div></div>
                    </Modal.Body>
                </div>
            </div>
            {alertMessageShowModal && <AlertMessagePopUpModal color='#00c12c' content={alertMessage} 
            showModal={alertMessageShowModal} 
            handleClose={() => 
                {closeAlertMessage();
                props.handleClose();
                props.setRefresh(true);
                //window.location.reload();
            }} />}
        </Modal>
    </>)
 }
 export default DeletePopUp;